import React from 'react';
import { Icon } from '../Icon';
import styles from './ReviewSlideV2.css';

const REVIEWS = [
    {
        title: 'A bridge to my kids, one story at a time',
        quote: 'My kids live abroad, and I don’t know when I’ll see them next. Perhaps through my stories, we’ll feel more connected.',
        name: 'Ruby',
        date: 'September',
        avatarColor: '#741818'
    },
    {
        title: 'As easy as talking to an old friend',
        quote: 'I’m not big on technology, but Boundly made it easy. I simply talked into my phone like I was chatting with an old friend. I want my kids to have our family stories.',
        name: 'Paul',
        date: 'September',
        avatarColor: '#178F29'
    },
    {
        title: 'Mom’s stories we never knew we were missing',
        quote: 'I got this for my mom and she remembered so many stories from her childhood, her first love, her whole life. We never knew half of it. The whole family is in awe. Best gift we’ve ever given her.',
        name: 'Natalie',
        date: 'September',
        avatarColor: '#167C91'
    }
];

function ReviewSlideV2() {
    return (
        <div className={styles.form}>
            <div className={styles.headingSection}>
                <h2 className={styles.heading}>Most of them weren’t sure either</h2>
                <p className={styles.description}>
                    The hardest part was believing there was anything worth writing down. This is what happened after they started.
                </p>
            </div>
            <ul className={styles.list}>
                {REVIEWS.map(review => (
                    <li key={review.name} className={styles.card}>
                        <span className={styles.avatar} style={{ backgroundColor: review.avatarColor }} aria-hidden='true'>
                            {review.name[0]}
                        </span>
                        <div className={styles.content}>
                            <div className={styles.authorRow}>
                                <p className={styles.author}><span className={styles.name}>{review.name},</span> {review.date}</p>
                                <Icon name='verifiedFill' className={styles.badgeIcon} />
                            </div>
                            <p className={styles.title}>{review.title}</p>
                            <p className={styles.quote}>{review.quote}</p>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export {
    ReviewSlideV2
};
